<div class="preview">

  <mat-card *ngIf="tab === 'thumbnail'" class="offer_start">
    <div class="loading" *ngIf="isLoading">
      <mat-spinner [color]="color" [diameter]="50"></mat-spinner>
    </div>

    <img mat-card-image [src]="image || imgDefault" alt="Photo">

    <mat-card-content>
      <div class="photo_experience" *ngIf="getPhotoExperience(offer?.photoExperience)">
        <p>{{offer?.photoExperience || 'Photo experience'}}</p>
      </div>
      <div class="infos_sub_img">
        <div class="infos">
          <div class="icon">
            <fa-icon [icon]="getFaIcon('faClockSolid')"></fa-icon>
          </div>
          {{offer?.duration || 'Durée'}}
        </div>
        <div class="infos">
          <div class="icon">
            <fa-icon [icon]="getFaIcon('faMapMarkedAlt')"></fa-icon>
          </div>
          <p>
            {{offer?.practicePlace?.label || offer?.practicePlace || 'Lieu de pratique'}}
          </p>
        </div>
      </div>

      <h4><strong>{{offer?.offerName || 'Titre de l\'offre'}}</strong></h4>

      <div class="tags">
        <ng-container *ngFor="let t of offer?.mainTags, let i = index">
          <div class="tag">{{t.tagName}} </div>
        </ng-container>
      </div>
      <p class="description" *ngIf="offer?.description" [innerHTML]="offer.description">
      </p>
      <p class="description" *ngIf="!offer?.description">
        Description de l'offre
      </p>

    </mat-card-content>

    <div class="btn_action">
      <div class="price">
        <div class="icon">
          <fa-icon [icon]="getFaIcon('faEuroSign')" appChangeColorTheme attribute="color"></fa-icon>
        </div>
        <span> {{offer?.price || 'Prix de l\'offre'}} </span>
      </div>


      <fa-icon [icon]="getFaIcon('faHeartEmpty')" appChangeColorTheme attribute="color">
      </fa-icon>
    </div>
  </mat-card>



</div>